@if (displayForm()) {
  <ct-extraction-behandler-form
    [currentActiveFieldModel]="currentFieldService.currentActiveFieldModel"
    [(currentActiveField)]="currentFieldService.currentActiveField"
    [(currentActiveSection)]="currentFieldService.currentActiveSection"
    (behandlerDataChanged)="onBehandlerDataChanged($event)"
    (behandlerDismissed)="onBehandlerDismissed()" />
} @else {
  <ct-extraction-behandler-list
    [behandlerData]="behandlerData()"
    (deleteBehandler)="onDeleteBehandler($event)"
    (assignBehandlerToSelectedDocument)="onAssignBehandlerToSelectedDocument($event)"
    (openBehandlerDetails)="onOpenBehandlerDetails($event)" />
}

@if (isDeletionDialogOpened()) {
  <shared-core-dialog
    [attr.data-testid]="'confirm-delete-behandler-dialog'"
    title="Behandler löschen"
    [blurBackground]="true"
    [(dialogOpened)]="isDeletionDialogOpened"
    (confirmed)="onConfirmBehandlerDeletion()">
    <div class="flex flex-col gap-4">
      <p>Bist du dir sicher, dass du den Behandler löschen möchtest?</p>
    </div>
  </shared-core-dialog>
}

@if (isConfirmContinueDialogOpened()) {
  <shared-core-dialog
    [attr.data-testid]="'confirm-continue-behandler-dialog'"
    title="Zuordnung bestätigen"
    [blurBackground]="true"
    [(dialogOpened)]="isConfirmContinueDialogOpened"
    (confirmed)="continue.emit()">
    <div class="flex flex-col gap-4">
      <p>Möchtest du die Zuordnung der Behandler abschließend?</p>
    </div>
  </shared-core-dialog>
}
